import {isRealNum} from './tools'
export default{
  install(Vue, options)
  {
    Vue.prototype.myData = {};
    Vue.prototype.getMyData = function (key) {
      return this.myData.key
    }
    Vue.prototype.setMyData = function (key, value) {
      this.myData[key] = value;
    }
    Vue.prototype.getTeamLogo = function (id, url) {
      if (isRealNum(id)) {
        id = Number(id);
        let arr = [637, 638, 642, 644, 645, 648, 649, 650, 735, 744, 746, 756, 765, 766, 767, 768, 772, 774, 775, 778, 783, 789, 798, 813, 815, 819, 823, 891, 898, 903, 913, 914];
        let index = arr.indexOf(id);
        if (index != -1) {
          return 'https://resource.ttplus.cn/h5/world-cup-wx/' + id + '.png';
        } else {
          if (url) {
            return url
          } else {
            return '../static/images/icon_zh_team.png'
            //return 'https://resource.ttplus.cn/h5/world-cup-wx/default.png';
          }

        }
      }
      return '../static/images/icon_zh_team.png'
      //return 'https://resource.ttplus.cn/h5/world-cup-wx/default.png';
    };
    //Vue.prototype.jsBridge = jsBridge;
    Vue.prototype.isApp = function () {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf('ttplus') != -1) {
        return true;
      }
      if (
        (typeof window.client != 'undefined')
        || (
          (typeof webkit != 'undefined')
          && (typeof webkit.messageHandlers != 'undefined')
          //不要打开下面的开关，否则会影响客户端的判断
          // && (typeof webkit.messageHandlers.login != 'undefined')
        )
      ) {
        return true;
      } else {
        return false;
      }
    };
    Vue.prototype.loadingBox = {
      show: function () {
        let loadingBox = window.document.getElementById('loading');
        if (loadingBox) {
          loadingBox.style.display = 'block';
        }
      },
      hide: function () {
        let loadingBox = window.document.getElementById('loading');
        if (loadingBox) {
          loadingBox.style.display = 'none';
        }

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/unit.js